export class AppSettings {
 //public static API_ENDPOINT = 'http://64.215.200.241:8080/educacionalcenterServer';
 //public static API_ENDPOINT = 'http://192.168.2.8:8080'; // PC Lucas
 //public static API_ENDPOINT = 'http://192.168.1.122:8080'; // PC Lucas
  // public static API_ENDPOINT = 'http://192.168.1.104:8080/educacionalcenterServer'; // PC Carlos
    public static API_ENDPOINT = 'http://localhost:8080/educacionalcenterServer'; // 
  //public static API_ENDPOINT = 'http://192.168.0.107:8080'; // PC Mariela
  //public static API_ENDPOINT = 'http://192.168.0.113:8080'; //PC Vivi
    //public static API_ENDPOINT = 'http://192.168.1.159:8080'; //PC Lucas
    // public static API_ENDPOINT = 'http://192.168.10.93:8080/educacionServer';
    // public static API_ENDPOINT = 'http://64.215.200.21:8080/saludServer';
    // public static API_ENDPOINT = 'http://64.215.200.200:8080/recipeServer';
    // public static API_ENDPOINT = 'http://64.215.200.200:8080/saludServer';
    // public static API_ENDPOINT = 'http://64.215.200.200:8080/educacionServer';
    // public static API_ENDPOINT = 'http://64.215.200.231:8080/saludServer';
    // public static API_ENDPOINT = 'http://64.215.200.233:8080/educacionalcenterServer'; // Test
  //public static API_ENDPOINT = 'http://64.215.200.237:8080/educacionalcenterServer';
   //public static API_ENDPOINT = 'http://64.215.200.21:8080/educacionalcenterServer';
  //public static API_ENDPOINT = 'http://192.168.10.93:8080/educacionalcenterServer';
  // http://64.215.200.237
    public static SING_OID = false;

}





// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/app.settings.ts